import React from "react";
import { useTranslation } from "react-i18next";

const RulesFooter = ({ dataCount }: { dataCount: number }) => {
  const { t } = useTranslation();

  return (
    <div className="bg-gray-50 text-xs font-medium text-gray-600 px-4 py-2 border-t border-gray-200">
      {`${dataCount} ${t("rulesEditor.rules")}`}
    </div>
  );
};

export default RulesFooter;
